import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Location } from '@angular/common';

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    selector: 'app-coming-soon',
    templateUrl: './coming-soon.component.html',
    styleUrls: ['./coming-soon.component.scss'],})
export class ComingSoonComponent {
  constructor(private location: Location) {}

  goBack(): void {
    this.location.back();
  }
}
